import { render, staticRenderFns } from "./CameraPreview.vue?vue&type=template&id=49d801d4&scoped=true&"
import script from "./CameraPreview.vue?vue&type=script&lang=ts&"
export * from "./CameraPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPreview.vue?vue&type=style&index=0&id=49d801d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d801d4",
  null
  
)

export default component.exports